import { convertValues } from './convert-values.js'
import { identifyIntercoParameters } from './identify-interco.js'
import { identifyNetZeros } from './identify-net-zeros.js'

/**
 *
 * @param {*} transactions
 * @param {*} params
 * @param {*} params.currenciesRates
 * @param {*} params.entities
 */
export function enrichTransactions (transactions, params) {
  convertValues(transactions, params)
  identifyIntercoParameters(transactions, params.dateGroupingMethod)
  identifyNetZeros(transactions)
}
